import { Grid, Tooltip, Typography } from "@mui/material"
import { formatDate } from "../../../../Utils/Utils"
import { CheckCircle, Edit } from "@mui/icons-material"

const TypographySx = {
    color: 'black',
    fontSize: '15px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
}

const IconSx = {
    cursor: 'pointer',
    fontSize: '38px',
    marginLeft: '10px',
    color: 'green'
}
const IconSxCircleG = {
    cursor: 'pointer',
    fontSize: '38px',
    marginLeft: '10px',
    color: 'green'
}
const IconSxCircleR = {
    cursor: 'pointer',
    fontSize: '38px',
    marginLeft: '10px',
    color: 'red'
}

const CardAutorizados = ({ id, nome, imovel, dt_inicial, dt_final, adicionarAutorizacao, editarAutorizacao, convite = false, setOpenModalAutorizacao }) => {
    const data_final = new Date(dt_final)
    const data_ontem = new Date()

    data_final.setHours(0, 0, 0, 0)
    data_ontem.setHours(0, 0, 0, 0)
    data_ontem.setDate(data_ontem.getDate() - 1)

    const data_anterior = data_final < data_ontem

    const vencida = dt_final.slice(0, 10) < new Date().toISOString().slice(0, 10)

    return (
        <Grid sx={{
            width: '100%',
            minHeight: '45px',
            maxHeight: '45px',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            background: 'white',
            borderRadius: '10px',
            padding: '0 10px 0 10px',
            boxShadow: '0 0 10px 0 rgba(0, 0, 0, 0.1)'
        }}>
            {convite ? null : <Edit sx={{ ...IconSx, marginRight: '10px' }} onClick={() => { editarAutorizacao(id); setOpenModalAutorizacao(true) }} />}
            <Tooltip title={nome} placement="bottom" arrow>
                <Typography sx={{ ...TypographySx, width: '40%' }}>{nome}</Typography>
            </Tooltip>
            <Tooltip title={imovel} placement="bottom" arrow>
                <Typography sx={{ ...TypographySx, width: '30%' }}>{imovel}</Typography>
            </Tooltip>
            <Tooltip title={formatDate(dt_inicial) + " - " + formatDate(dt_final)} placement="bottom" arrow>
                <Typography sx={{ ...TypographySx, width: '25%', color: data_anterior ? 'red' : 'black' }}>{formatDate(dt_inicial)} - {formatDate(dt_final)}</Typography>
            </Tooltip>
            <Tooltip title="Selecionar Autorização" placement="bottom" arrow>
                <CheckCircle sx={vencida ? IconSxCircleR : IconSxCircleG} onClick={() => { adicionarAutorizacao() }} />
            </Tooltip>
        </Grid>
    )
}

export default CardAutorizados
